<template>
  <div class="edit-style-weight-and-italic">
    <div class="common-buttons-box">
      <button type="button"
        :class="{'active': selectedFontWeight}"
        @click="updateStyles('font-weight')">
        <i class="fas fa-bold"></i>
      </button>
      <button type="button"
        :class="{'active': selectedStyleItalic}"
        @click="updateStyles('font-style')">
        <i class="fas fa-italic"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'fontWeight',
    'fontStyle'
  ],
  computed: {
    selectedFontWeight () {
      return this.fontWeight === 'bold'
    },
    selectedStyleItalic () {
      return this.fontStyle === 'italic'
    }
  },
  methods: {
    updateStyles (prop) {
      let updateValue = null
      // スタイル未設定の場合のみ、値をセットする
      if (prop === 'font-weight' && !this.selectedFontWeight) updateValue = 'bold'
      if (prop === 'font-style' && !this.selectedStyleItalic) updateValue = 'italic'
      const styles = [
        { prop: prop, value: updateValue }
      ]
      this.$emit('updateStyles', styles)
    },
  }
}
</script>
